import { ListItemIcon, ListItemText, MenuItem, StyledEngineProvider, ThemeProvider } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Icon } from '../../../../atoms';
import { theme } from '../../../../electrons';
import useStyles from './ContextMenuOption.styles';
export const CellContextIconOptionRenderer = (icon, customTheme) => {
    return (_hot, wrapper, _row, _col, _prop, itemValue) => {
        const root = createRoot(wrapper);
        root.render(React.createElement(StyledEngineProvider, { injectFirst: true },
            React.createElement(ThemeProvider, { theme: customTheme || theme },
                React.createElement(ContextMenuOption, { label: itemValue, icon: icon }))));
        return wrapper;
    };
};
export function ContextMenuOption(props) {
    const classes = useStyles();
    return (React.createElement(MenuItem, { className: classes.container },
        React.createElement(ListItemIcon, { classes: { root: classes.iconContainer } },
            React.createElement(Icon, { className: classes.icon }, props.icon)),
        React.createElement(ListItemText, { classes: { primary: classes.label } }, props.label)));
}
export default ContextMenuOption;
//# sourceMappingURL=ContextMenuOption.js.map